module.exports = __webpack_public_path__ + "static/img/parallax_trgovci_p.fe4ffc00.jpg";